import { v4 as uuidv4 } from "uuid";
import { maybeGetRecordingEmailAttachmentMetadata } from "../entities/attachment.js";
function extractRecordingEmailFromAttachment(attachment) {
  const recordingEmailAttachment = maybeGetRecordingEmailAttachmentMetadata(
    attachment.metadata
  );
  if (!recordingEmailAttachment || !recordingEmailAttachment.email) {
    return null;
  }
  return {
    subject: recordingEmailAttachment.email.subject,
    body: recordingEmailAttachment.email.body
  };
}
const defaultAssessmentTree = {
  nodes: [
    {
      type: "section",
      id: uuidv4(),
      name: "Sales fundamentals",
      description: "Core competencies for effective sales and customer service interactions",
      nodes: [
        {
          type: "criteria",
          id: uuidv4(),
          name: "Product and market knowledge",
          description: "",
          grading_context: "Demonstrates comprehensive understanding of products, services, and market landscape",
          grading_value_type: "1_5_score"
        },
        {
          type: "criteria",
          id: uuidv4(),
          name: "Discovery and active listening",
          description: "",
          grading_context: "Effectively uncovers customer needs through thoughtful questioning and attentive listening",
          grading_value_type: "1_5_score"
        },
        {
          type: "criteria",
          id: uuidv4(),
          name: "Objection handling",
          description: "",
          grading_context: "Addresses customer concerns professionally and persuasively",
          grading_value_type: "1_5_score"
        }
      ]
    }
  ]
};
export {
  defaultAssessmentTree,
  extractRecordingEmailFromAttachment
};
//# sourceMappingURL=recordingHelpers.js.map
